import React, { useState, useEffect } from "react";
import { Box, Card, CardActionArea, CardContent, Typography, Stack, useMediaQuery } from "@mui/material";

const sampleRecommendations = [
  // {
  //   type: "podcast",
  //   content: "Peter Thiel // The Diversity Myth, 30 Years Later",
  //   title: 'https://podcasts.apple.com/us/podcast/peter-thiel-the-diversity-myth-30-years-later/id1123461944?i=1000627021583',
  //   query: 'https://podcasts.apple.com/us/podcast/peter-thiel-the-diversity-myth-30-years-later/id1123461944?i=1000627021583',
  //   factChecked: false,
  // },
  {
    type: "video",
    content: "CNA: Half a million people in Singapore suffer from kidney disease",
    query: 'https://youtu.be/_qcLpNBleDM',
    title: "https://youtu.be/_qcLpNBleDM",
    factChecked: true,
    link : "https://app.facticity.ai/c/fa301f22-35f0-49a1-a221-a1abde7f54cd"

  }
];

const preFactCheckedSamples = [
  {
    type: "text",
    content: "MrBeast said, 'Life is so much easier when you’re broke'",
    title: "Click to view the assessment of the fact-checked claims",
    query: "MrBeast said, 'Life is so much easier when you’re broke'",
    factChecked: true,
    link: "https://app.facticity.ai/c/914f2860-ad83-4cbf-960f-382924f674f5",
  },
  {
    type: "para",
    content: "President Trump & Tariffs: Fact Sheet",
    query: "MrBeast said, 'Life is so much easier when you’re broke'",
    title: "Click to view the assessment of the fact-checked claims",
    factChecked: true,
    link: "https://app.facticity.ai/c/e268e2a9-7fec-44ac-b09c-4700ca7f4e30",
  },
  {
    "type": "podcast",
    "content": "Peter Thiel, The Diversity Myth, 30 Years Later",
    "query": "https://podcasts.apple.com/us/podcast/peter-thiel-the-diversity-myth-30-years-later/id1123461944?i=1000627021583",
    "title": "Click to view the assessment of the fact-checked claims",
    "factChecked": true,
    "link": "https://app.facticity.ai/c/2cbf00f8-2772-41d5-a4a9-5243d1a47479",
  }
];

const ExampleCards = ({ setSearchQuery, setInternalTrigger }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const allSamples = [...preFactCheckedSamples, ...sampleRecommendations];
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (isMobile) {
      const interval = setInterval(() => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % allSamples.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [isMobile, allSamples.length]);

  const handleCardClick = (sample) => {
    if (sample.factChecked) {
      window.open(sample.link, "_blank");
    } else {
      setSearchQuery(sample.query);
      setInternalTrigger((prevState) => !prevState);
    }
  };

  return (
    <Box
  sx={{
    display: "grid",
    gridTemplateColumns: { xs: isMobile ? "1fr" : "repeat(2, 1fr)", sm: "repeat(2, 1fr)" },
    gap: 1.5,
    mt: 0.25,
    px: { xs: 1, sm: 2 },
    maxWidth: "100%",
    justifyContent : isMobile? "center": "initial"
  }}
>
  {isMobile ? (
    <Box sx={{ position: "relative", width: "100%", display: "flex", flexDirection : "column", alignItems: "center" }}>
      <Card
        sx={{
          width: "100%",
          maxWidth: "90%",
          borderRadius: 2,
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          transition: "box-shadow 0.3s ease",
          "&:hover": { boxShadow: "0 6px 14px rgba(0, 0, 0, 0.2)" },
        }}
        onClick={() => handleCardClick(allSamples[activeIndex])}
      >
        <CardActionArea
          component={allSamples[activeIndex].factChecked ? "a" : "div"}
          href={allSamples[activeIndex].factChecked ? allSamples[activeIndex].link : undefined}
          target={allSamples[activeIndex].factChecked ? "_blank" : undefined}
        >
          <CardContent sx={{ pt: 2, pb: 1 }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography
                variant="caption"
                sx={{
                  px: 0.5,
                  py: 0.2,
                  color: allSamples[activeIndex].factChecked ? "#155724" : "#1E88E5",
                  fontSize: "10px",
                  fontWeight: "bold",
                  borderRadius: 1,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                {allSamples[activeIndex].factChecked ? "View Fact-Checked Assessment ✅" : "Start New Fact-Check 🔍"}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  px: 0.5,
                  py: 0.2,
                  backgroundColor: ["text", "para"].includes(allSamples[activeIndex].type) ? "#D4EDDA" : "#E3F2FD",
                  color: ["text", "para"].includes(allSamples[activeIndex].type) ? "#757575" : "#D32F2F",                  
                  fontSize: "10px",
                  fontWeight: "bold",
                  borderRadius: 1,
                }}
              >
              {
                allSamples[activeIndex].type === "text" 
                  ? "Text Claim" 
                  : allSamples[activeIndex].type === "video"
                  ? "YouTube" 
                  :allSamples[activeIndex].type === "podcast"
                  ? "Apple Podcast"
                  : "Paragraph/Long Check"
              }
              </Typography>
            </Stack>

            <Typography variant="body2" sx={{ fontSize: "12px", mt: 1 }}>
              {allSamples[activeIndex].content}
            </Typography>
            {allSamples[activeIndex].title !== "None" && (
              <Typography
                variant="caption"
                sx={{ display: "block", mt: 1, color: "text.disabled", fontSize: "10px" }}
                noWrap
              >
                {allSamples[activeIndex].title}
              </Typography>
            )}
          </CardContent>
        </CardActionArea>
      </Card>

      {/* Navigation Dots */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
        {allSamples.map((_, index) => (
          <Box
            key={index}
            sx={{
              width: 8,
              height: 8,
              mx: 0.5,
              borderRadius: "50%",
              backgroundColor: index === activeIndex ? "#1E88E5" : "#C4C4C4",
              transition: "background-color 0.3s",
              
            }}
            onClick={() => setActiveIndex(index)}
          />
        ))}
      </Box>
    </Box>
  ) : (
    allSamples.map((sample, index) => (
      <Card
        key={index}
        sx={{
          width: "100%",
          borderRadius: 2,
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          transition: "box-shadow 0.3s ease",
          "&:hover": { boxShadow: "0 6px 14px rgba(0, 0, 0, 0.2)" },
        }}
        onClick={() => handleCardClick(sample)}
      >
        <CardActionArea
          component={sample.factChecked ? "a" : "div"}
          href={sample.factChecked ? sample.link : undefined}
          target={sample.factChecked ? "_blank" : undefined}
        >
          <CardContent sx={{ pt: 3, pb: 2 }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography
                variant="caption"
                sx={{
                  px: 0.5,
                  py: 0.2,
                  color: sample.factChecked ? "#155724" : "#1E88E5",
                  fontSize: "12px",
                  fontWeight: "bold",
                  borderRadius: 1,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                {sample.factChecked ? "View Fact-Checked Assessment ✅" : "Start New Fact-Check 🔍"}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  px: 0.5,
                  py: 0.2,
                  backgroundColor: ["text", "para"].includes(allSamples[activeIndex].type) ? "#D4EDDA" : "#E3F2FD",
                  color: ["text", "para"].includes(allSamples[activeIndex].type) ? "#757575" : "#D32F2F",                  
                  fontSize: "10px",
                  fontWeight: "bold",
                  borderRadius: 1,
                }}
              >
                  {{
                  text: "Text Claim",
                  video: "YouTube",
                  podcast: "Apple Podcast"
                }[sample.type] || "Paragraph/Long Check"}
                </Typography>
            </Stack>

            <Typography variant="body2" sx={{ fontSize: "14px", mt: 1 }}>
              {sample.content}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    ))
  )}
</Box>

  );
};

export default ExampleCards;
